import { Avatar, Flex } from "antd";
import styled from "styled-components";

const backgroundSize = "8px";

export const StyledAppAvatarContainer = styled(Flex)`
  align-items: normal !important;
  cursor: pointer;
`;
export const StyledAppAvatar = styled(Avatar)`
  border: 1px solid ${({ theme }) => theme.palette.borderColor.main};
`;
export const StyledAppAvatarSVGWrapper = styled.span`
  margin-left: -10px !important;
  z-index: 1000 !important;
  position: relative !important;
  top: -${backgroundSize} !important;
  font-size: 14px !important;
  svg {
    position: relative;
    z-index: 1000;
    fill: blue !important;
  }
`;

export const StyledAppAvatarSVGBackground = styled.span`
  background: white;
  height: ${backgroundSize};
  width: 7px;
  display: block;
  position: relative;
  z-index: 1;
  top: 11px;
  right: -4px;
  border-radius: 50%;
`;
